import classNames from 'classnames'
import { FC, memo } from 'react'
import { isWeekend } from 'utils/date'

type DataCellProps = React.PropsWithChildren<{
  data: {
    startDate: Date
  }
}>

export const DataCell: FC<DataCellProps> = memo((props) => {
  return (
    <div
      className={classNames(
        'w-full h-full',
        isWeekend(props.data.startDate) && 'crew-scheduler-weekend'
      )}
    >
      {props.children}
    </div>
  )
})
